/**
 * Configuração da Avaliação de Perfis de Comunicação
 * 
 * Este arquivo centraliza as configurações relacionadas à avaliação,
 * permitindo facilmente alternar entre versões completa e reduzida.
 */

export interface AssessmentConfig {
  // Configuração principal
  useShortVersion: boolean;
  
  // Limites
  shortVersionQuestions: number;
  fullVersionQuestions: number;
  
  // Tempos estimados (em minutos)
  shortVersionTime: number;
  fullVersionTime: number;
  
  // Configurações de análise
  minConfidenceForValidResult: number;
  showAnalysisQualityNote: boolean;
}

// Configuração ativa - ATUALIZADA PARA TESTE COMPLETO
export const ASSESSMENT_CONFIG: AssessmentConfig = {
  // Configuração alterada para sempre usar versão completa
  useShortVersion: false, // Sempre usa avaliação completa para máxima precisão
  
  // Limites de questões
  shortVersionQuestions: 5,
  fullVersionQuestions: 40,
  
  // Tempos estimados
  shortVersionTime: 2, // 2 minutos
  fullVersionTime: 12, // 8-12 minutos
  
  // Configurações de análise
  minConfidenceForValidResult: 80, // Aumentado para 80% devido à maior precisão
  showAnalysisQualityNote: false // Removido pois agora sempre temos análise completa
};

// Funções utilitárias
export const getExpectedQuestions = (): number => {
  return ASSESSMENT_CONFIG.useShortVersion 
    ? ASSESSMENT_CONFIG.shortVersionQuestions 
    : ASSESSMENT_CONFIG.fullVersionQuestions;
};

export const getEstimatedTime = (): number => {
  return ASSESSMENT_CONFIG.useShortVersion 
    ? ASSESSMENT_CONFIG.shortVersionTime 
    : ASSESSMENT_CONFIG.fullVersionTime;
};

export const isShortAssessment = (numQuestions: number): boolean => {
  return numQuestions <= ASSESSMENT_CONFIG.shortVersionQuestions;
};

export const getAssessmentTypeLabel = (): string => {
  return ASSESSMENT_CONFIG.useShortVersion ? 'Avaliação Rápida' : 'Avaliação Completa';
};

export const getAssessmentDescription = (): string => {
  if (ASSESSMENT_CONFIG.useShortVersion) {
    return `Avaliação rápida com ${ASSESSMENT_CONFIG.shortVersionQuestions} questões estratégicas (${ASSESSMENT_CONFIG.shortVersionTime} minutos)`;
  }
  return `Avaliação completa com ${ASSESSMENT_CONFIG.fullVersionQuestions} questões detalhadas (${ASSESSMENT_CONFIG.fullVersionTime} minutos)`;
};